import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";
import ExceptionLogger from "../ExceptionHelper";
import { PlusIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/PlusIcon";
import { EditIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/EditIcon";
import { DeleteIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/DeleteIcon";
import { AcceptIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/AcceptIcon";
import { ClearIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/ClearIcon";
import { Tr, Td, TextArea, Text, Anchor } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import GetLiveChatHeader from "../LiveChatHeaderHelper";


export class CannedMessageEditor extends React.Component {
    constructor(props) {
        super(props);

        const UhaulReducer = uhaulStore.getState().UhaulReducer;
        
        this.currentUser = UhaulReducer.currentUser;
        this.postServiceUrl = props.postServiceUrl;
        this.state = {
            readOnly: props.viewModel.Id != null,
            addNew: props.viewModel.Id == null,
            viewModel: {
                Id: props.viewModel.Id,
                QueueId: props.viewModel.QueueId,
                Title: props.viewModel.Title,
                Description: props.viewModel.Description,
                ModifiedByName: this.currentUser.workerName,
                ModifiedByHrGuid: this.currentUser.hrGuid
            }
        };
        this.api = {
            get: this.postServiceUrl,
            post: `${this.postServiceUrl}CannedMessages`,
            put: `${this.postServiceUrl}CannedMessages/${this.state.viewModel.Id}`
        };

        this.handleViewModelChange = this.handleViewModelChange.bind(this);
    }

    handleViewModelChange(event) {
        const { viewModel } = { ...this.state };
        const currentState = viewModel;
        const { name, value } = event.target;
        currentState[name] = value;

        this.setState({ viewModel: currentState });
    }

    handleCancel() {
        try
        {
            fetch(this.api.put,
            {
                method: "GET",
                headers: GetLiveChatHeader() 
            })
            .then(response => {
                if(response && response.ok)
                {
                    return response.json();
                }
                else{
                    throw new Error(`Cannot pull from ${this.api.put}`);
                }
            })
            .then(json => {
                if (!json.Success || !json.Data) {
                    const errorMessage = json.Errors ? json.Errors.join(" | ") : "Unknown error.";
                    ExceptionLogger(errorMessage, "CannedMessageEditor.handleCancel", errorMessage);
                    return;
                }
                
                const messages = json.Data;
                this.setState({
                    readOnly: !this.state.addNew,
                    viewModel: {
                        Id: null,
                        QueueId: this.state.viewModel.QueueId,
                        Title: messages && messages.Title ? messages.Title : "",
                        Description: messages && messages.Description ? messages.Description : "",
                        ModifiedByName: this.state.viewModel.ModifiedByName,
                        ModifiedByHrGuid: this.state.viewModel.ModifiedByHrGuid
                    }
                });
            })
            .catch(error => {
                ExceptionLogger(error, "CannedMessages.getAllMessages", "Error with fetching Canned Messages.");
            });
        }
        catch(err){
            ExceptionLogger(error, "CannedMessageEditor.handleCancel", "Error with canceling the editing of a Canned Message.")
            console.log(error);
        }
    }

    handleEdit() {
        this.setState({
            readOnly: false,
            viewModel: this.props.viewModel
        });
    }

    handleDelete(event) {
        event.preventDefault();
        if (!window.confirm('Are you sure you wish to delete this message?')) {
            return;
        }
        fetch(this.api.put,
                {
                    method: "delete",
                    headers: GetLiveChatHeader()
                })
            .then(response => response.json())
            .then(this.props.handleCannedMessagesDelete(this.state.viewModel.Id))
            .catch(error => {ExceptionLogger(error, "CannedMessageEditor.handleDelete", "Error with deleting Canned Message.")
                    console.log(error);
                });
    }

    handleSubmit(event) {
        event.preventDefault();
        fetch(this.state.addNew ? this.api.post : this.api.put,
                {
                    method: this.state.addNew ? "post" : "put",
                    headers: GetLiveChatHeader(),
                    body: JSON.stringify(this.state.viewModel)
                })
            .then(response => response.json())
            .then(json => {
                if (!json.Success || !json.Data) {
                    var errorMessage = json.Errors ? json.Errors.join("\n") : "Unknown error.";
                    window.alert(errorMessage);
                    return;
                }

                this.props.handleCannedMessagesSubmit(json.Data);
                this.handleCancel();
            })
            .catch(error => {ExceptionLogger(error, "CannedMessageEditor.handleSubmit", "Error with saving Canned Message.")
                    console.log(error);
                });
    }

    render() {
        try
        {
            if(this.props && this.state)
            {
                return (
                    <Tr key={this.props.viewModel.Id}>
                        <Td>
                        {this.state.readOnly ? (
                                (this.state.viewModel.Title && this.state.viewModel.Title != "" ? this.state.viewModel.Title 
                                                                                                : (this.props.viewModel.Title && this.props.viewModel.Title != "" ? this.props.viewModel.Title : "N/A"))
                        ) : (
                            <TextArea name="Title" value={this.state.viewModel.Title} placeholder="Title..." onChange={this.handleViewModelChange} required />
                        )}
                        </Td>
                        <Td>
                        {this.state.readOnly ? (
                            (this.state.viewModel.Description && this.state.viewModel.Description != "" ? this.state.viewModel.Description 
                                                                                : (this.props.viewModel.Description && this.props.viewModel.Description != "" ? this.props.viewModel.Description : "N/A"))
                        ) : (
                            <TextArea name="Description" defaultValue={this.state.viewModel.Description} value={this.state.viewModel.Description} placeholder="Description..." onChange={this.handleViewModelChange} required />
                        )}
                        </Td>
                        <Td>
                        {this.state.readOnly ? (
                            <Text as="span">
                                <Anchor onClick={this.handleEdit.bind(this)}><EditIcon decorative={false} title="Edit"/></Anchor>
                                <Anchor onClick={this.handleDelete.bind(this)}><DeleteIcon decorative={false} title="Delete"/></Anchor>
                            </Text>
                            ) : (
                            <Text as="span">
                            {this.state.addNew ? (
                                <Anchor onClick={this.handleSubmit.bind(this)}><PlusIcon decorative={false} title="Add"/></Anchor>
                            ) : (
                                <Anchor onClick={this.handleSubmit.bind(this)}><AcceptIcon decorative={false} title="Save"/></Anchor>
                            )}
                            {!this.state.addNew &&
                                <Anchor onClick={this.handleCancel.bind(this)}><ClearIcon decorative={false} title="Cancel"/></Anchor>
                            }
                            </Text>
                        )}
                        </Td>
                    </Tr>
                );
            }
            else{
                return (<Tr key={this.props.viewModel.Id}>
                    <Td><p className="warning">Error with displaying canned messages.</p></Td>
                    <Td><p className="warning">Please refresh.</p></Td>
                    </Tr>)
            }
        }
        catch(err){
            ExceptionLogger(error, "CannedMessageEditor.render", "Error with rendering Canned Message.")
            console.log(error);
        }
    }
}